export default function (uku) {
    this.yourName = "";
};


//////////////////
// WEBPACK FOOTER
// ./resources/js/example02.js
// module id = 6
// module chunks = 0